import BranchScanningRecordReport from './branch_scanning_record_report.vue';

export default BranchScanningRecordReport;
